import {wymsFetch, getParams} from '@/utils/fetch';

// 查询学校列表
export function queryAuthLoginList(args) {
    const params = getParams(true, args);
    params.append('searchVal', args.searchVal);
    params.append('status', args.status);

    return wymsFetch({
        url: 'auth/queryAuthLoginList',
        method: 'GET',
        params
    });
}

// 切换到授权账号
export function updateRunasAuthLogin(args) {
    const params = getParams();
    params.append('id', args.id);
    params.append('userId', args.userId);

    return wymsFetch({
        url: 'auth/updateRunasAuthLogin',
        method: 'GET',
        params
    });
}
// 是否切换用户
export function queryRunAs() {
    return wymsFetch({
        url: 'auth/queryRunAs',
        method: 'get'
    });
}

// 退出切换(切回自己)
export function updateReleaseRunAs() {

    return wymsFetch({
        url: 'auth/updateReleaseRunAs',
        method: 'GET',
    });
}

// 查询账号登录用户
export function queryPrimitiveLoginUser() {

    return wymsFetch({
        url: 'auth/queryPrimitiveLoginUser',
        method: 'GET',
    });
}

// 查询经销商列表全部
export function queryBussinessListAll() {

    return wymsFetch({
        url: 'bussiness/queryBussinessListAll',
        method: 'GET',
    });
}

// 查询客服负责的学校
export function querySchoolListByUserId(args) {
    const params = getParams();
    params.append('userId', args.userId);

    return wymsFetch({
        url: 'auth/querySchoolListByUserId',
        method: 'GET',
        params
    });
}

// 申请授权
export function insertAuthLogin(args) {
    const params = getParams();
    params.append('id', args.id);
    params.append('loginname', args.loginname);
    params.append('name', args.name);
    params.append('schoolIds', args.schoolIds);

    return wymsFetch({
        url: 'auth/insertAuthLogin',
        method: 'POST',
        data: params
    });
}
// 查询经销商用户列表
export function queryBusinessNumberList(args) {
    const params = getParams();
    params.append('businessId', args.businessId);

    return wymsFetch({
        url: 'bussiness/queryBusinessNumberList',
        method: 'GET',
        params
    });
}



// WEBPACK FOOTER //
// ./src/api/empower.js